import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from '@env/environment';
import { CoreModule } from '@core';
import { SharedModule } from '@shared';
import { AuthModule } from '@app/auth';
import { HomeModule } from './home/home.module';
import { ShellModule } from './shell/shell.module';
import { FifaSubscrieService } from '../services/fifaSubscrie.service';
//import { AboutModule } from './about/about.module';
import { ProductService } from '../services/productservice';
import { CanonicalService } from '../services/canonical.service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MegaMenuModule } from 'primeng/megamenu';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { GalleriaModule } from 'primeng/galleria';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { SliderModule } from 'primeng/slider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { IslandsAllComponent } from './islands-all/islands-all.component';
import { LoaderInterceptor } from '../services/loader-interceptor';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { FaqComponent } from './faq/faq.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { themeReducer } from '../state/theme.reducer';
import { ThemeEffects } from '../state/theme.effects';

@NgModule({
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot(),
    NgbModule,
    CoreModule,
    SharedModule,
    PanelModule,
    BrowserAnimationsModule,
    ShellModule,
    HomeModule,
    //AboutModule,
    AuthModule,
    MegaMenuModule,
    CarouselModule,
    ButtonModule,
    ToastModule,
    GalleriaModule,
    CardModule,
    SliderModule,
    ProgressSpinnerModule,
    InputTextareaModule,
    InputNumberModule,
    OverlayPanelModule,
    StoreModule.forRoot({ theme: themeReducer }),
    EffectsModule.forRoot([ThemeEffects]),
    AppRoutingModule, // must be imported as the last module as it contains the fallback route
  ],
  declarations: [AppComponent, IslandsAllComponent, CookiePolicyComponent, NotFoundComponent, FaqComponent],
  providers: [
    ProductService,
    CanonicalService,
    FifaSubscrieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
